<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="400px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onAbort"
        @click:outside="onAbort"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Drukowanie raportów
                </h1>
            </v-card-title>

            <v-data-table
                v-model="reportsSelectedToPrint"
                :headers="printDialogHeaders"
                :items="reports"
                item-key="code"
                show-select
                hide-default-footer
                disable-pagination
                :mobile-breakpoint="0"
                name="printReportsData"
            >
                <template #item.report="{item}">
                    {{ item.name }}
                </template>
            </v-data-table>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onAbort"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Drukuj"
                    :loading="actionLoading"
                    :disabled="reportsSelectedToPrint.length == 0"
                    @click="printReports(reportsSelectedToPrint)"
                >
                    Drukuj
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'PrintReportsDialog',
    props: {
        jobId: {
            type: Number,
            default: null
        },
        isOpen: {
            type: Boolean
        },
        actionLoading: {
            type: Boolean
        }
    },
    data() {
        return {
            reports: [
                {
                    name: 'Handlowcy',
                    code: 'job_report_trader'
                },
                {
                    name: 'Druk',
                    code: 'job_report_print'
                },
                {
                    name: 'Intro',
                    code: 'job_report_cut'
                },
                {
                    name: 'CTP',
                    code: 'job_report_ctp'
                }
            ],
            reportsSelectedToPrint: [],
            printDialogHeaders: [
                {
                    text: 'Typ',
                    align: 'left',
                    sortable: false,
                    value: 'report'
                },
            ]
        }
    },
    methods: {
        printReports(reportsSelectedToPrint) {
            const templateCodes = reportsSelectedToPrint.map(item => item.code)

            setTimeout(() => {
                this.reportsSelectedToPrint = []
            }, 500)

            this.$emit('on-confirm', {
                jobId: this.jobId,
                templateCodes: templateCodes
            })
        },
        onAbort() {
            setTimeout(() => {
                this.reportsSelectedToPrint = []
            }, 500)

            this.$emit('on-abort')
        }
    }
}
</script>
